import { Button } from "@mui/material";

const ButtonComponent = ({
    label,
    variant="contained",
    onClick,
    inLoading,
    sx,
    ...other
}) => {
    return(
        <>
            <Button
                variant={variant}
                onClick={onClick}
                loading={inLoading}
                sx={{
                    py: 1.5,
                    textTransform: 'none',
                    ...sx
                }}
                {...other}
                className="onMouseOver"
            >
                {label}
            </Button>
        </>
    );
}

export default ButtonComponent;